import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { IBSidebarData } from '../../../components/global/sidebar/sidebarData/IBSidebarData.jsx';

/** Already in IB bottom bar — hide from More menu (Reports kept with same children as desktop) */
const BOTTOM_BAR_TITLES = new Set(['Dashboard', 'IB Wallet', 'My Team', 'Commission']);

const IBSettingsMobile = () => {
  const navigate = useNavigate();
  const [openGroups, setOpenGroups] = useState({ Reports: true });

  const menuItems = IBSidebarData
    .filter((item) => !BOTTOM_BAR_TITLES.has(item.title))
    .filter((item) => item?.url || item?.child?.length);

  const toggleGroup = (title) => {
    setOpenGroups((prev) => ({ ...prev, [title]: !prev[title] }));
  };

  return (
    <div className="min-h-screen">
      <div className="space-y-3 mb-8">
        {menuItems.map((item) => {
          const hasChildren = !!item.child?.length;
          const isOpen = !!openGroups[item.title];

          if (item.url && !hasChildren) {
            return (
              <div
                key={item.title}
                className="bg-white rounded-xl p-4 min-h-[56px] cursor-pointer active:bg-gray-50 transition-colors"
                onClick={() => navigate(item.url, { state: { title: item.title } })}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <div className="h-10 w-10 shrink-0 grid place-items-center bg-[#E2E8F0] rounded-[14px]">
                      {item.icon}
                    </div>
                    <span className="text-gray-800 font-medium text-base">{item.title}</span>
                  </div>
                  <div className="w-8 h-8 shrink-0 grid place-items-center bg-[#E2E8F0] rounded-[10px]">
                    <RightOutlined className="text-[#45556C] text-sm" />
                  </div>
                </div>
              </div>
            );
          }

          return (
            <div key={item.title} className="bg-white rounded-xl overflow-hidden">
              <button
                type="button"
                className="w-full flex items-center justify-between p-4 min-h-[56px] active:bg-gray-50 transition-colors"
                onClick={() => toggleGroup(item.title)}
                aria-expanded={isOpen}
              >
                <div className="flex items-center space-x-3">
                  <div className="h-10 w-10 shrink-0 grid place-items-center bg-[#E2E8F0] rounded-[14px]">
                    {item.icon}
                  </div>
                  <div className="text-left">
                    <span className="block text-gray-800 font-medium text-base">{item.title}</span>
                    <span className="block text-xs text-gray-500 mt-0.5">
                      {item.child.length} options
                    </span>
                  </div>
                </div>
                <div
                  className={`w-8 h-8 shrink-0 grid place-items-center bg-[#E2E8F0] rounded-[10px] transition-transform duration-200 ${
                    isOpen ? 'rotate-180' : ''
                  }`}
                >
                  <DownOutlined className="text-[#45556C] text-xs" />
                </div>
              </button>

              <div
                className={`grid transition-[grid-template-rows] duration-200 ease-out ${
                  isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
                }`}
              >
                <div className="overflow-hidden">
                  <div className="border-t border-gray-100 mx-4" />
                  <div className="px-2 pb-2 pt-1">
                    {item.child.map((child, index) => (
                      <button
                        key={child.title}
                        type="button"
                        className={`w-full flex items-center justify-between gap-3 min-h-[52px] px-3 rounded-xl active:bg-gray-50 transition-colors ${
                          index < item.child.length - 1 ? 'border-b border-gray-50' : ''
                        }`}
                        onClick={() => navigate(child.url, { state: { title: child.title } })}
                      >
                        <div className="flex items-center gap-3 min-w-0">
                          {child.icon ? (
                            <div className="h-9 w-9 shrink-0 grid place-items-center bg-[#F1F5F9] rounded-xl text-[#45556C]">
                              {child.icon}
                            </div>
                          ) : null}
                          <span className="text-gray-800 font-medium text-[15px] truncate">
                            {child.title}
                          </span>
                        </div>
                        <RightOutlined className="text-[#94A3B8] text-xs shrink-0" />
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IBSettingsMobile;
